import { createUseStyles } from 'react-jss';

export const useCheckoutStepsStyles = createUseStyles({
  CheckoutStepsContent: {
    '& li .arrow': {
      width: '5px',
      height: '8px',
      backgroundImage: 'url("/images/checkout/steps/arrow.svg")',
    },
    '& li:last-child .arrow': {
      display: 'none',
    },
  },
});
